webpackJsonp([202660965941462],{

/***/ 437:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/projects-header-big.012612db.jpg";

/***/ }),

/***/ 438:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/projects-header-small.ced326c2.jpg";

/***/ }),

/***/ 38:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.List = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEmotion = __webpack_require__(6);
	
	var _reactEmotion2 = _interopRequireDefault(_reactEmotion);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var listStyle = /*#__PURE__*/(0, _reactEmotion.css)('list-style-type:none;margin:0;& h1{color:inherit;text-decoration:underline;}& a{color:black;cursor:pointer;opacity:1;transition:opacity .15s ease-in;transition:color .15s ease-in;&:hover{text-decoration:none;box-shadow:none;opacity:.5;transition:opacity .15s ease-in;}}');
	
	var List = exports.List = function List(_ref) {
	  var children = _ref.children;
	
	  return _react2.default.createElement(
	    'ul',
	    { className: listStyle },
	    children
	  );
	};

/***/ }),

/***/ 177:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.pageQuery = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Hero = __webpack_require__(12);
	
	var _Hero2 = _interopRequireDefault(_Hero);
	
	var _projectsHeaderBig = __webpack_require__(437);
	
	var _projectsHeaderBig2 = _interopRequireDefault(_projectsHeaderBig);
	
	var _projectsHeaderSmall = __webpack_require__(438);
	
	var _projectsHeaderSmall2 = _interopRequireDefault(_projectsHeaderSmall);
	
	var _Layout = __webpack_require__(7);
	
	var _Lists = __webpack_require__(38);
	
	var _gatsbyLink = __webpack_require__(19);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _colors = __webpack_require__(3);
	
	var _colors2 = _interopRequireDefault(_colors);
	
	var _config = __webpack_require__(52);
	
	var _config2 = _interopRequireDefault(_config);
	
	var _SEO = __webpack_require__(26);
	
	var _SEO2 = _interopRequireDefault(_SEO);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (_ref) {
	  var data = _ref.data;
	  var projects = data.allMarkdownRemark.edges;
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_SEO2.default, {
	      title: _config2.default.siteTitle,
	      description: _config2.default.siteDescription
	    }),
	    _react2.default.createElement(
	      _Hero2.default,
	      {
	        imageBig: _projectsHeaderBig2.default,
	        imageSmall: _projectsHeaderSmall2.default
	      },
	      _react2.default.createElement(
	        _Layout.Box,
	        { color: 'white', p: [3, 3, 4], align: 'left' },
	        _react2.default.createElement(
	          'h1',
	          null,
	          'Projects'
	        )
	      )
	    ),
	    _react2.default.createElement(
	      _Layout.Box,
	      { color: _colors2.default.black, p: [3, 3, 4], align: 'left' },
	      _react2.default.createElement(
	        _Lists.List,
	        null,
	        projects.map(function (_ref2, index) {
	          var project = _ref2.node;
	
	          return _react2.default.createElement(
	            'li',
	            { key: index },
	            _react2.default.createElement(
	              _Layout.ContentWrapper,
	              null,
	              _react2.default.createElement(
	                'h1',
	                null,
	                _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: project.fields.slug },
	                  project.frontmatter.title
	                )
	              ),
	              _react2.default.createElement(
	                'p',
	                null,
	                project.frontmatter.description
	              )
	            )
	          );
	        })
	      )
	    )
	  );
	};
	
	var pageQuery = exports.pageQuery = '** extracted graphql fragment **';

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-projects-index-js-7815eb311517cf8675ef.js